import React, { Component } from 'react';
import './navbar_global.scss';
import MainMenu from "../../main_menu/main_menu";
import { Nav, Navbar } from 'react-bootstrap';
import Dropdown from 'react-dropdown';
import 'react-dropdown/style.css';
import { isMobileOnly } from "react-device-detect";

import navbar_logo from '../../../assets/navbar_logo.svg';
import navbar_search_button from '../../../assets/navbar_search_button.svg';
import { Translation } from "react-i18next";
import { API_CONFIG } from "../../../config/api_config";
import axios from "axios";
import { Link } from "react-router-dom";
import { HIGH_LEVEL_CONFIG } from "../../../config/high_level_config";
import { findPageInMenuTree } from "../../../utils/menu";

const SVG_ID = "#svg_id";

class LuissNavbar extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isHidden: true,
            gcseIsHidden: true,
            hamburgerState: '',
            selectedLanguageOption: 'IT',
            breadcrumb: [],
            titleArray: [],
            urlArray: [],
            menu: []
        };
        this.toggleMenu = this.toggleMenu.bind(this);
    }

    componentDidMount() {
        this.fetchMenuItems();
        setTimeout(() => {
            var cx = '001096623058387578145:v5aiydfg6ku';
            var gcse = document.createElement('script');
            gcse.type = 'text/javascript';
            gcse.async = true;
            gcse.src = 'https://cse.google.com/cse.js?cx=' + cx;
            var s = document.getElementsByTagName('script')[0];
            s.parentNode.insertBefore(gcse, s);
        }, HIGH_LEVEL_CONFIG.GOOGLE_SEARCH_DELAY_SECONDS * 1000);
    }


    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.language !== prevProps.language) {
            this.fetchMenuItems();
        }
        if (this.props.path !== prevProps.path || this.props.breadcrumb !== prevProps.breadcrumb) {
            this.findCurrentPage();
        }
    }

    /**
     * Find the current page in the menu.
     * We run a Depth First Search to find the current page in the menu and save its path
     */
    findCurrentPage(menu) {
        let breadcrumb = [];
        if (this.props.breadcrumb && !!this.props.breadcrumb.length) {
            breadcrumb = [{ title: "Home", url: "/" }, ...this.props.breadcrumb];
        } else {
            let menuItems = menu || this.state.menu;
            let tree = {
                title: "Home",
                relative: "/",
                below: menuItems
            };

            breadcrumb = this.props.path.includes("/summer_course/") ?
                [{ title: "Home", url: "/" }, { title: window.localStorage.getItem("summercourse"), url: this.props.path }] :
                findPageInMenuTree(this.props.path, tree);
        }
        console.log("[LOG]: Current breadcrumb is: " + breadcrumb);

        this.setState({
            breadcrumb: breadcrumb
        });
    }

    async fetchMenuItems() {
        try {
            const menuId = this.props.language === "en" ? API_CONFIG.ENGLISH_MENU_ID : API_CONFIG.ITALIAN_MENU_ID;
            const response = await axios.get(`${API_CONFIG.BASE_URL}/menu/${this.props.language}/${menuId}?max_depth=6`);
            let stateUpdates = {};
            if (response.status < 300) {
                this.setState({
                    menu: response.data
                });
                this.findCurrentPage(response.data);

                let titleArray = this.state.menu.map(item => item.title);
                let urlArray = this.state.menu.map(item => item.relative);
                this.setState({
                    titleArray: titleArray,
                    urlArray: urlArray
                });
            } else {
                console.log("Cannot load data for the MAIN MENU");
            }
            this.setState(stateUpdates);
            return response.data;
        } catch (error) {
            console.log(error);

            this.setState({
                menu: []
            });
            return null;
        }
    }

    changeLanguage = selectedLanguageOption => {
        this.setState({
            selectedLanguageOption
        });
        this.props.changeLanguage(selectedLanguageOption.value);
    };

    toggleMenu = () => {
        this.setState({
            isHidden: !this.state.isHidden,
            hamburgerState: (this.state.isHidden) ? 'open' : '',
        });
    };

    hideGCSE = (value) => {
        this.setState({
            gcseIsHidden: true
        });
        window.location.assign(value);
    };

    toggleGCSE = () => {
        this.setState({
            gcseIsHidden: !this.state.gcseIsHidden
        });
    };

    render() {
        let navbarColor = (!this.state.isHidden || !this.state.gcseIsHidden) ? 'dark' : this.props.baseColor;
        const optionsLanguage = [{ value: 'it', label: 'IT' }, { value: 'en', label: 'EN' }, { value: 'zh', label: 'ZH' }];

        return (
            <Navbar id="luiss-navbar" variant="dark" className={navbarColor + '-text desktopnav'}>
                <Navbar.Brand onClick={() => this.hideGCSE('/')} style={{ cursor: "pointer" }}>LUISS
                    <svg className="navbar-logo">
                        <use xlinkHref={`${navbar_logo}${SVG_ID}`} />
                    </svg>
                </Navbar.Brand>
                {!isMobileOnly &&
                    <div className="breadcrumb-bar">
                        {this.state.isHidden && this.state.breadcrumb && this.state.breadcrumb.length > 1 && this.state.breadcrumb.map((breadcrumbPiece, index) =>
                            <span key={"breadcrumb-link-" + breadcrumbPiece.title}>
                                <Link key={"breadcrumb-" + breadcrumbPiece.title} to={breadcrumbPiece.url}>{breadcrumbPiece.title}</Link>
                                {index === this.state.breadcrumb.length - 1 ? "" :
                                    <span key={"breadcrumb-sep-" + breadcrumbPiece.title}>&nbsp;&nbsp;&nbsp;/&nbsp;&nbsp;&nbsp;</span>}
                            </span>
                        )}
                    </div>
                }
                <Translation>
                    {(t) =>
                        <Nav key="nav-top" className={navbarColor + '-text mx-auto navbar-navigation-menu'}>
                            {this.state.isHidden && this.state.urlArray && this.state.urlArray.length >= 4 &&
                                <>
                                    <a href={'https://socialtv.luiss.it'} className="Ateneo socialtv">Social TV</a>
                                    {/*<a href={'https://youtube.com/live/fzTgR0FZ7cY'} className="Ateneo socialtv">Social TV</a>*/}
                                    
                                    <a key="nav-ateneo" href={this.props.language=="it"?"https://landing.luiss.it/chi-siamo/index.html":"https://landing.luiss.it/chi-siamo/en.html"} className="Ateneo">{this.props.language=="it"?"Chi Siamo":"The University"}</a>
                                    <Link key="nav-corsi" to={this.props.language=="it"?"/it/corsi-e-master":"/en/programs"} className="Corsi-e-Master">{this.props.language=="it"?"Corsi e Master":"Programmes"}</Link>
                                    {/* the api doesn't have url and title for luiss uniqueness so we hardcode it */}
                                    {/* {this.props.language === 'it' ?
                                        <Link key="nav-career" to={'/faq-lauree-magistrali-digitali'} className="luiss-uniqueness">Lauree Digitali</Link> :
                                        <Link key="nav-career" to={'/faq-digital-masters-degrees'} className="luiss-uniqueness">Digital Programs</Link>} */}

                                    <Link key="nav-ricerca" to={this.props.language=="it"?"/it/ricerca":"/en/research-eng"} className="Ricerca">{this.props.language=="it"?"Ricerca":"Research"}</Link>
                                    <Link key="nav-scholarship" to={this.props.language=="it"?"/studenti/agevolazioni-economiche":"/financial-aid-and-scholarships"} className="Ricerca">{this.props.language=="it"?"Borse di studio":"Scholarships"}</Link>
                                    <Link key="nav-apply" to={this.props.language=="it"?"/ammissione":"/how-to-apply"} className="Ricerca">{this.props.language=="it"?"Entra in Luiss":"Apply Now"}</Link>
                                    <Link key="nav-events" to={this.props.language=="it"?"/it/eventi":"/en/all-events"} className="Ricerca">{this.props.language=="it"?"Eventi":"Events"}</Link>
                                    {/*Delete this comment after you publish the link below*/}
                                    {/* {this.props.language === 'it' ?
                                        <a key="nav-summer-school" href={this.state.urlArray[4]} className="Ricerca">{this.state.titleArray[4]}</a> : null} */}
                                    {/*{this.props.language === 'it' ?*/}
                                    {/*    <a key="nav-summer-school" href={"http://static.luiss.it/summer-school-2020"} className="Ricerca">Summer School</a> : null}*/}


                                    {/* Talk to Luiss menu item */}
                                    {/* {this.props.language === 'en' ?
                                    <Link key="nav-other-1" to={this.state.urlArray[4]} className="Ricerca">{this.state.titleArray[4]}</Link> : null} */}
                                    {/* {this.props.language === 'en' ?
                                        <Link key="nav-other-2" to={this.state.urlArray[5]} className="Entra-in-Luiss">{this.state.titleArray[5]}</Link> : null} */}
                                </>
                            }
                        </Nav>
                    }
                </Translation>
                <div className={navbarColor + '-shadow'} />
                <Nav className="navbar-right">
                    <Nav.Link className="navbar-right-dropdown">
                        {/* eslint-disable-next-line jsx-a11y/heading-has-content */}
                        <Dropdown options={optionsLanguage} onChange={this.changeLanguage} value={this.props.language}
                            className={navbarColor + '-text dropdown-language'} />
                    </Nav.Link>

                    {/*START - Google Custom Search Engine*/}
                    <div className="navbar-right-searchfield">
                        <div id="search-container" className={this.state.gcseIsHidden ? "gcseIsHidden" : ""}>
                            <div className="gcse-searchbox" id="gcseDivElement">
                                <div className="gcse-search-field">
                                    <div className="gcse-searchbox" />
                                </div>
                                <div className="gcse-search-results">
                                    <div className="gcse-searchresults" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <Nav.Link className="navbar-right-search" onClick={this.toggleGCSE} aria-label="Search">
                        <svg className="navbar-search mb-2">
                            <use xlinkHref={`${navbar_search_button}${SVG_ID}`} />
                        </svg>
                    </Nav.Link>
                    {/*END - Google Custom Search Engine*/}

                    <Nav.Link className="navbar-right-menu" onClick={this.toggleMenu} aria-label="Full Menu">
                        <div id="nav-icon3" className={this.state.hamburgerState + ' ' + this.props.baseColor}>
                            <span />
                            <span />
                            <span />
                            <span id="bottom_bar" />
                        </div>
                    </Nav.Link>
                    {!this.state.isHidden &&
                        <MainMenu language={this.props.language} changeLanguage={this.props.changeLanguage} menu={this.state.menu}
                            languageTag={this.state.selectedLanguageOption} />}
                </Nav>
            </Navbar>
        );
    }
}

export default LuissNavbar;
